import {CommentsCategory} from '@domain/comments'
import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import type {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useCommentsQueryParams {
  plantCode: string
  commentsCategory: CommentsCategory
  commentCategoryInstanceIds: (string | number)[]
  enabled?: boolean
}

export const useCommentsQuery = ({
  plantCode,
  commentsCategory,
  commentCategoryInstanceIds,
  enabled = true
}: useCommentsQueryParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'comments',
    enabled,
    params: [{plantCode, commentsCategory, commentCategoryInstanceIds}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useCommentsQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching comments')

      spawnErrorToast(t('error.comments'))

      return false
    }
  })
}
